import React, { useContext } from "react";
import "src/components/contactsales/ContactSales.css";
import { ContactItemSales, ContactItemRow } from "src/components/contactsales/contactitemsales/ContactItemSales";
import { UI } from "@wwimmo/ui";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { CustomerPartner } from "src/components/customer/Customer";
import contacts from "./ContactSales.json";

export enum ContactItemType {
    PHONE,
    MAIL
}

export interface ContactSalesProps {
    cardDesign?: boolean;
    square?: boolean;
    displayTitle?: boolean;
    useResponsiveCols?: boolean;
    actionText?: string;
    actionButtonText?: string;
    actionButtonEmailAddress?: string;
}

export const ContactSales = (props: ContactSalesProps) => {
    const { t } = useTranslation();
    const { navStore } = useContext(RootStoreContext);

    const {
        square,
        displayTitle = true,
        useResponsiveCols,
        cardDesign = true,
        actionText,
        actionButtonText,
        actionButtonEmailAddress
    } = props;

    const contactSales = contacts.contactSales;

    const contentWW: Array<ContactItemRow> = [
        { type: ContactItemType.PHONE, content: contactSales[0]?.tel || null },
        { type: ContactItemType.MAIL, content: contactSales[0]?.email || null }
    ];
    const contentExtenso: Array<{ type: ContactItemType; content: string | null }> = [
        { type: ContactItemType.PHONE, content: contactSales[1]?.tel || null },
        { type: ContactItemType.MAIL, content: contactSales[1]?.email || null }
    ];

    const responsiveColProps = useResponsiveCols ? { sm: 6, lg: 4, xl: 3 } : {};

    return (
        <>
            {cardDesign ? (
                <UI.Col {...responsiveColProps}>
                    <UI.Card square={square} title={displayTitle ? t("screens.contact.title").toString() : ""}>
                        <div className="ContactSales">
                            {navStore.customer.partner === CustomerPartner.WW ? (
                                <>
                                    <div className="ContactName">{contactSales[0].company}</div>
                                    <div className="ContactTitle">{contactSales[0].department}</div>
                                    <ContactItemSales name={contactSales[0].company} contacts={contentWW} />
                                </>
                            ) : navStore.customer.partner === CustomerPartner.EXTENSO ? (
                                <>
                                    <div className="ContactName">{contactSales[1].company}</div>
                                    <div className="ContactTitle">{contactSales[1].department}</div>
                                    <ContactItemSales name={contactSales[0].company} contacts={contentExtenso} />
                                </>
                            ) : undefined}
                        </div>
                    </UI.Card>
                </UI.Col>
            ) : (
                <div className="ContactSalesContainer">
                    {actionText && <div>{actionText}</div>}
                    {actionButtonText && (
                        <a
                            href={`mailto:${
                                actionButtonEmailAddress
                                    ? actionButtonEmailAddress
                                    : navStore.customer.partner === CustomerPartner.WW
                                    ? contentWW[1].content
                                    : navStore.customer.partner === CustomerPartner.EXTENSO
                                    ? contentExtenso[1].content
                                    : ""
                            }`}
                            className="mb-2"
                            style={{ textDecoration: "none" }}
                        >
                            <UI.Button className={"ticket-button mt-2"} label={actionButtonText}></UI.Button>
                        </a>
                    )}
                    {navStore.customer.partner === CustomerPartner.WW ? (
                        <>
                            <div className="ContactSalesName">{contactSales[0].company}</div>
                            <div className="ContactSalesTitle">{contactSales[0].department}</div>
                            <ContactItemSales name={contactSales[0].company} contacts={contentWW} />
                        </>
                    ) : navStore.customer.partner === CustomerPartner.EXTENSO ? (
                        <>
                            <div className="ContactSalesName">{contactSales[1].company}</div>
                            <div className="ContactSalesTitle">{contactSales[1].department}</div>
                            <ContactItemSales name={contactSales[0].company} contacts={contentExtenso} />
                        </>
                    ) : undefined}
                </div>
            )}
        </>
    );
};
